import { IFloorPlanHit } from '@/lib/search/types';
import { ISortOption } from '../or-filtered-grid.types';

export const plansSortOptions: ISortOption[] = [
  {
    label: 'Most Popular',
    value: 'popular',
    sortFn: (a, b) => {
      // Find first popular floor plan from each
      const aPopularFP = a.FloorPlans?.find(
        (fp: IFloorPlanHit) => fp.IsPopular,
      );
      const bPopularFP = b.FloorPlans?.find(
        (fp: IFloorPlanHit) => fp.IsPopular,
      );

      const aIsPopular = !!aPopularFP;
      const bIsPopular = !!bPopularFP;

      // If both are popular, sort by PopularRank
      if (aIsPopular && bIsPopular) {
        return (
          (aPopularFP.PopularRank || 10000) - (bPopularFP.PopularRank || 10000)
        );
      }

      // If only one is popular, it comes first
      if (aIsPopular) return -1;
      if (bIsPopular) return 1;

      // If neither is popular, sort by SquareFeet
      const aSqFt = a.SquareFeet || 0;
      const bSqFt = b.SquareFeet || 0;
      return bSqFt - aSqFt;
    },
  },
  {
    label: 'Name (A–Z)',
    value: 'name-asc',
    sortFn: (a, b) => (a.Plan?.Name ?? '').localeCompare(b.Plan?.Name ?? ''),
  },
  {
    label: 'Square Feet (Low–High)',
    value: 'sqft-asc',
    sortFn: (a, b) => (a.SquareFeet ?? 0) - (b.SquareFeet ?? 0),
  },
  {
    label: 'Square Feet (High–Low)',
    value: 'sqft-desc',
    sortFn: (a, b) => (b.SquareFeet ?? 0) - (a.SquareFeet ?? 0),
  },
  {
    label: 'Price (Low–High)',
    value: 'price-asc',
    sortFn: (a, b) => (a.BaseElevationPrice ?? 0) - (b.BaseElevationPrice ?? 0),
  },
  {
    label: 'Price (High–Low)',
    value: 'price-desc',
    sortFn: (a, b) => (b.BaseElevationPrice ?? 0) - (a.BaseElevationPrice ?? 0),
  },
];
